import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import cs from "classnames";

import Loading from "components/Loading";
import CustomTable from "components/CustomTable";

import UnitForm from "../../components/Form/UnitForm";

import useEditForm from "hooks/useEditForm";
import useRoles from "hooks/useRoles";

export default function Unit() {
	const { units } = useSelector(state => state.data);

	const [data, setData] = useState({ nodes: [] });
	useEffect(() => {
		if (units === null) return;
		setData({
			nodes: Object.values(units).sort((a, b) => a.name.localeCompare(b.name)),
		});
	}, [units]);

	const columns = [
		{
			label: "Název",
			renderCell: unit => unit.name,
			sort: { sortKey: "NAME" },
		},
		{
			label: "Adresa",
			renderCell: unit => unit.address,
			sort: { sortKey: "ADDRESS" },
		},
		{
			label: "Doména",
			renderCell: unit => <a href={unit.domain}>{unit.domain}</a>,
			sort: { sortKey: "DOMAIN" },
		},
	];

	const sortFns = {
		NAME: array => array.sort((a, b) => a.name.localeCompare(b.name)),
		ADDRESS: array => array.sort((a, b) => a.address.localeCompare(b.address)),
		DOMAIN: array => array.sort((a, b) => a.domain.localeCompare(b.domain)),
	};

	const { toggle, setToggle, editing, setEditing, formKey } = useEditForm();

	const { isAdmin } = useRoles();

	if (units === null) return <Loading />;

	return (
		<main>
			<h2>
				<picture>
					<source srcSet="/images/icons/unit_color.svg" />
					<img width="36px" src="/images/icons/unit_color.svg" alt="Ikona jednotky" />
				</picture>
				Jednotky
				<menu>
					{isAdmin ? (
						<button
							className={cs("action_button", { active: toggle })}
							onClick={() => setToggle(prevState => !prevState)}>
							{toggle ? "Zavřít formulář" : "Přidat jednotku"}
						</button>
					) : null}
				</menu>
			</h2>
			{toggle && <UnitForm initialValues={units[editing]} id={editing} key={formKey} />}
			<CustomTable
				title="Seznam všech jednotek"
				layout="minmax(10rem, 1fr) minmax(10rem, 1fr) minmax(10rem, 1fr)"
				data={data}
				columns={columns}
				sortFns={sortFns}
				actions={["edit", "delete"]}
				setEditing={setEditing}
			/>
		</main>
	);
}
